import { render } from "./BackerCenterGiftCardGroupSkeleton.vue?vue&type=template&id=3fba2ce0"
import script from "./BackerCenterGiftCardGroupSkeleton.vue?vue&type=script&lang=js"
export * from "./BackerCenterGiftCardGroupSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__